import _ from 'lodash'
import React from 'react'
import {Modal} from 'react-bootstrap'

type Props = {
  handleClose?: () => void
  message?: any
}

const ErrorModal: React.FC<Props> = ({handleClose, message}) => {
  return (
    <Modal
      id='gori_order_modal_error'
      tabIndex={-1}
      aria-hidden='true'
      centered
      dialogClassName='modal-size-md h-auto'
      contentClassName='modal-padding'
      show={!_.isEmpty(message)}
      onHide={handleClose}
    >
      <Modal.Header closeButton>
        <Modal.Title bsPrefix={'fw-bolder fs-1'}></Modal.Title>
      </Modal.Header>
      <Modal.Body className='vh-75 overflow-auto'>
        <div className='fw-bolder fs-3 text-danger'>{message}</div>
      </Modal.Body>
    </Modal>
  )
}

export {ErrorModal}
